<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";
  import { _ } from "svelte-i18n";

  import DayParameters from "./DayParameters.svelte";
  import Modal from "./Modal.svelte";

  let modalActive = false;
  let date = new Date();

  function showModal() {
    modalActive = true;
    window.document.body.classList.toggle("modal-is-active");
  }

  const storedUser = localStorage.getItem("user");
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "(ditt navn)",
          surname: "",
        };

  const sessionsResult = useQuery("sessions", () =>
    user.id !== undefined
      ? superagent
          .get("/api/sessions")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => response.body)
      : []
  );

  let sessions;
  $: {
    let storedSessions = localStorage.getItem("sessions");
    sessions = (
      storedSessions !== null ? JSON.parse(storedSessions) : []
    ).concat($sessionsResult.isLoading ? [] : $sessionsResult.data);
  }

  const daysResult = useQuery("days", () =>
    user.id !== undefined
      ? superagent
          .get("/api/days")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => response.body)
      : []
  );

  let days;

  $: {
    let storedDays = localStorage.getItem("days");
    days = (storedDays !== null ? JSON.parse(storedDays) : []).concat(
      $daysResult.isLoading ? [] : $daysResult.data
    );
  }
</script>

<div class="page-body">
  <div class="content">
    <button on:click={showModal} class="button-log-activity">{$_("sessions.form.submit")}</button>
    <div class="layout layout--masonry">
      <DayParameters {days} bind:date gender={user?.gender} />
    </div>
  </div>
  <Modal bind:active={modalActive} {sessions} {date} />
</div>
